const labels = {
  changeBackground: "Change Background",
  contactInfo: "Información de Contacto",
  chat: "Chats",
  typeYourMessage: "Escribe aquí ..."
};

export default labels;
